import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Box,
  Button,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Tooltip,
  Popover,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import SettingsIcon from '@mui/icons-material/Settings';
import { NavLink, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

import ChartSettings from './Settings';

// const pages = ['Gym', 'Vote'];
const menuAuthPages = ['Gym', 'Vote', 'Login', 'Signup'];
const menuUserPages = ['Gym', 'Vote', 'Home', 'Logout'];

function ResponsiveAppBar({ isAuthenticated, score, playMoney }) {
  const location = useLocation();
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [actionAnchorEl, setActionAnchorEl] = useState(null);
  const [settingsAnchorEl, setSettingsAnchorEl] = useState(null);
  const [navMenu, setNavMenu] = useState(menuAuthPages);

  useEffect(() => {
    setNavMenu(isAuthenticated ? menuUserPages : menuAuthPages);
  }, [isAuthenticated]);

  const handleOpenNavMenu = (event) => setAnchorElNav(event.currentTarget);
  const handleOpenActionMenu = (event) => setActionAnchorEl(event.currentTarget);
  const handleCloseActionMenu = () => setActionAnchorEl(null);

  const handleCloseMenu = () => {
    setAnchorElNav(null);
  };
  const handleOpenSettings = (event) => setSettingsAnchorEl(event.currentTarget);
  const handleCloseSettings = () => setSettingsAnchorEl(null);

  const handleSave = () => {
    window.dispatchEvent(new CustomEvent("saveGymProgress"));
    handleCloseActionMenu();
    // You might want to close the popover here as well
  };

  const handleResetClick = () => {
    window.dispatchEvent(new CustomEvent("resetGymProgress"));
    handleCloseActionMenu();
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: "grey", height: "40px", justifyContent: "center" }}>
      <Toolbar disableGutters sx={{ minHeight: "40px", height: "40px", px: 1, display: "flex" }}>
        {/* Left side: Menu + Settings */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {/* Mobile Menu Icon */}
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="small"
              aria-label="open navigation menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              open={Boolean(anchorElNav)}
              onClose={handleCloseMenu}
              zIndex={2000}
            >
              {navMenu.map((page) => (
                <MenuItem
                  key={page}
                  component={NavLink}
                  to={`/${page.toLowerCase()}`}
                  onClick={handleCloseMenu}
                >
                  {page}
                </MenuItem>
              ))}
            </Menu>
          </Box>

          {/* Settings Icon */}
          <Box sx={{ ml: 2, display: { xs: "flex", md: "none" } }}>
            <Tooltip title="Settings">
              <IconButton sx={{ p: 0 }} onClick={handleOpenSettings}>
                <SettingsIcon sx={{ color: "white", width: 30, height: 30 }} />
              </IconButton>
            </Tooltip>
            <Popover
              open={Boolean(settingsAnchorEl)}
              anchorEl={settingsAnchorEl}
              onClose={handleCloseSettings}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              zIndex={2000}
              // PaperProps={{ sx: { zIndex: 2000 } }}
            >
              <ChartSettings />
            </Popover>
          </Box>
        </Box>

        {/* Center: Balance & Score */}
        {(location.pathname === '/gym' || location.pathname === '/') ? (
          <Box sx={{ flexGrow: 1, textAlign: "center" }}>
            <Typography variant="body2" sx={{ color: "white", fontWeight: "bold" }}>
              Balance: ${playMoney.toFixed(2)} | Score: {score}
            </Typography>
          </Box>
        ) : (
          <Box sx={{ flexGrow: 1 }} />
        )}

        {/* Right side: Logo */}
        <Box sx={{ mr: 0.5, display: { xs: "flex", md: "none" } }}>
          <Tooltip title={location.pathname === "/" ? "Save & Restart" : ""}>
            <IconButton
              onClick={location.pathname === "/" || location.pathname === "/gym" ? handleOpenActionMenu : undefined}
              sx={{ p: 0, cursor: location.pathname === "/gym" ? "pointer" : "default" }}
            >
              <img
                alt="CM"
                src="/assets/images/logo128.png"
                width="30"
                height="30"
              />
            </IconButton>
          </Tooltip>
          <Popover
            open={Boolean(actionAnchorEl)}
            anchorEl={actionAnchorEl}
            onClose={handleCloseActionMenu}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            zIndex={2000}
            // PaperProps={{ sx: { zIndex: 2000 } }}
          >
            <Box sx={{ p: 2 }}>
              <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave}>
                Save
              </Button>
              <Button variant="outlined" onClick={handleResetClick}>
                Reset
              </Button>
            </Box>
          </Popover>
        </Box>
      </Toolbar>
    </AppBar>
  );

}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  score: state.settings.score,
  playMoney: state.settings.playMoney,
});

export default connect(mapStateToProps)(ResponsiveAppBar);
